// extracted by mini-css-extract-plugin
export default {"loading":"speakLoading_loading__gBPJJ","item":"speakLoading_item__pKC7U","scale":"speakLoading_scale__Hh0OS"};